import { Component, Input, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import isUAWebview from "is-ua-webview";
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse  } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';

import { FunctService } from '../../services/funct.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-need-help',
  templateUrl: './need-help.component.html',
  styleUrls: ['./need-help.component.scss']
})

export class NeedHelpComponent implements OnInit {

  deviceId:any;
  openUrl: any;
  isWebview: any;
  result: any;
  phone_no: any;

  constructor (
    private storage: LocalStorageService,
    private http: HttpClient,
    private funct: FunctService,
    public common: CommonService,
  ) {

    this.deviceId = this.storage.retrieve('localDeviceId');  
    this.isWebview = isUAWebview(navigator.userAgent);    
    if (navigator.userAgent.indexOf("Mi") != -1 && this.isWebview) {
      this.openUrl = "";
    }
    if (this.deviceId != null || this.isWebview) {
      this.openUrl = ""; // ?openinnewtap=1
    } else {
      this.openUrl = "";
    }

  }

  ngOnInit(): void {
    this.getPhoneNumber();
  }

  getPhoneNumber = async() => {
    let headers = new HttpHeaders(); 

    this.http.get( this.funct.ipaddress + 'service/Getphone', { headers: headers } )
    .pipe(
      catchError(this.handleError.bind(this))
    ).subscribe(
      result => {
        this.result = result[0];
        this.phone_no = result[0].details[0].phone_no;
    });
  }

  handleError(error: HttpErrorResponse) {
    if (error.status == 0) {
      this.common.errorMsg("", "checkInternet", "top");
      return;

    } else if (error.status == 400) {
      this.common.errorMsg("", "bad_request", "top");
      return;

    }
    // return throwError(error); +818045983733 may zin aung
  }

}
